export default class AxiosResponse {
    data;
    status;
    statusText;
    headers;
    config;
    request;
    constructor(data) {
        Object.assign(this, data);
    }
}
